import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Backdrop, Button } from "@mui/material";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import '../Search/Search.css';
import Header from '../../../components/Header/Header';
import NewNavBar from '../../../components/NewNavBar/NewNavBar';
import environment from "../../../environment/environment";
import Footer from "../../../components/Footer/Footer";
import CustomSpinner from "../../../components/CustomeSpinner/CustomeSpinner";

const Search = () => {
    const [packageDetails, setPackageDetails] = useState([])
    const navigate = useNavigate()
    const [selectedPackage, setSelectedPackage] = useState(null);
    const [productDetails, setProductDetails] = useState([]);
    const [suggestions, setSuggestions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
        fetchData();
    }, []);

    const fetchData = async () => {
        setIsLoading(true);
        try {
            const [packagesRes, routesRes] = await Promise.all([
                axios.get(`${environment.config.apiBaseUrl}package/getAllPackagesName`),
                axios.get(`${environment.config.apiBaseUrl}route/getAllRoutePackages`, {
                    headers: {
                        authorization: "your token comes here",
                    },
                }),
            ]);
            setTimeout(() => {
                setIsLoading(false);
            }, 1500);

            const packages = packagesRes.data.packageList.map(pkg => ({
                ...pkg,
                label: pkg.packageName,
                type: 'package',
            }));

            const routes = routesRes.data.map(route => ({
                ...route,
                label: route.routeName,
                type: 'route',
            }));

            setSuggestions([...packages, ...routes]);
        } catch (error) {
            console.error(error);
            setTimeout(() => {
                setIsLoading(false);
            }, 1500);
        } finally {
            setTimeout(() => {
                setIsLoading(false);
            }, 1500);
        }
    };

    const handleChangeSearch = () => {
        if (selectedPackage) {
            if (selectedPackage.type === 'package') {
                navigate(`/package-details/:${selectedPackage.packageUID}`);
            } else if (selectedPackage.type === 'route') {
                navigate(`/tour/${selectedPackage.routeId}`);
            }
        }
    };

    const getAllPackages = () => {
        axios.get(`${environment.config.apiBaseUrl}package/getAllPackagesName`)
            .then((response) => {
                setPackageDetails(response.data.packageList);
            })
            .catch((error) => { });
    }

    const getAllRoute = () => {
        setIsLoading(true)
        axios({
            url: `${environment.config.apiBaseUrl}route/getAllRoutePackages`,
            method: "GET",
            headers: {
                authorization: "your token comes here",
            },
        })
            .then((res) => {
                if (res && res.data) {
                    setProductDetails(res.data);
                    setTimeout(() => {
                        setIsLoading(false);
                    }, 1500);
                }
            })
            .catch((err) => {
                setTimeout(() => {
                    setIsLoading(false);
                }, 1500);
            });
    }
    return (
        <>
            <Header />
            <NewNavBar />
            {isLoading &&
                <Backdrop
                    sx={{
                        color: "#fff",
                        zIndex: (theme) => theme.zIndex.drawer + 1,
                        backdropFilter: "blur(5px)",
                        backgroundColor: "rgba(0, 0, 0, 0.4)"
                    }}
                    open={isLoading}
                >
                    <CustomSpinner color="inherit" />
                </Backdrop>
            }
            <div className="container search-container" style={{ height: '100vh' }}>
                <div className="searchinput">
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                        maxWidth: '600px',
                    }}>
                        <Autocomplete
                            className="search-inputfield"
                            disablePortal
                            options={suggestions}
                            getOptionLabel={(option) =>
                                option.type === 'package'
                                    ? `📦 ${option.packageName}`
                                    : `🛣️ ${option.routeName}`
                            }
                            fullWidth
                            sx={{
                                flex: 1,
                                '& .MuiOutlinedInput-root': {
                                    borderTopRightRadius: 0,
                                    borderBottomRightRadius: 0,
                                },
                                width: "700px"
                            }}
                            renderInput={(params) => {
                                const { InputProps, ...rest } = params;
                                return (
                                    <TextField
                                        {...rest}
                                        InputProps={{
                                            ...InputProps,
                                            sx: {
                                                borderRight: 'none',
                                            }
                                        }}
                                        label="Search packages or routes..."
                                    />
                                );
                            }}
                            onChange={(event, newValue) => { setSelectedPackage(newValue) }}
                        />

                        <Button
                            className="search-button"
                            variant="contained"
                            sx={{
                                height: '56px',
                                borderTopLeftRadius: 0,
                                borderBottomLeftRadius: 0,
                                minWidth: '80px',
                                color: "black",
                                backgroundColor: '#fff099'
                            }}
                            onClick={handleChangeSearch}
                        >
                            Search
                        </Button>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default Search
